/* Wingman Wallet — promo banner + hero animation */
(function(){ if(window.__wmInit) return; window.__wmInit=true;
  const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];

  /* promo banner: kies actieve campagne op datum */
  $$('.wm-promo').forEach(el=>{
    const camps=$$('[data-camp]',el).map(c=>({el:c,from:c.dataset.from,to:c.dataset.to,deadline:c.dataset.deadline,always:c.dataset.always==='true'}));
    const now=new Date();
    let active=camps.find(c=>c.from&&c.to&&now>=new Date(c.from)&&now<=new Date(c.to+'T23:59:59'))||camps.find(c=>c.always);
    if(!active){el.hidden=true;return;}
    camps.forEach(c=>c.el.hidden=c!==active);
    el.className='wm-promo '+(active.el.dataset.theme||'');
    el.hidden=false;
    /* verzendklok: verzending ma t/m vr, besteld voor 17:00 (NL-tijd) = volgende dag in huis */
    const msg=$('.wm-promo__msg',active.el);
    if(msg&&active.el.dataset.ship==='true'){
      const DAYS=['zondag','maandag','dinsdag','woensdag','donderdag','vrijdag','zaterdag'],WD={Sun:0,Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6},CUT=17*3600;
      const fmt=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Amsterdam',weekday:'short',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
      const p2=n=>String(n).padStart(2,'0'),cap=s=>s[0].toUpperCase()+s.slice(1);
      const ship=()=>{
        const p={};fmt.formatToParts(new Date()).forEach(x=>p[x.type]=x.value);
        const w=WD[p.weekday],s=(+p.hour%24)*3600+(+p.minute)*60+(+p.second);
        let d=0; if(!(w>=1&&w<=5&&s<CUT)){d=1;while((w+d)%7<1||(w+d)%7>5)d++;}
        const rem=d*86400+CUT-s,sd=(w+d)%7,del=d===0?'Morgen':cap(DAYS[(sd+1)%7]);
        const when=rem<86400?'binnen <b class="wm-promo__clock">'+(rem>=3600?Math.floor(rem/3600)+' u ':'')+p2(Math.floor(rem%3600/60))+' min '+p2(rem%60)+' s</b>':'vóór '+DAYS[sd]+' 17:00';
        msg.innerHTML='<p><strong>'+del+' in huis.</strong> Bestel '+when+'</p>';
      };
      try{ship();setInterval(ship,1000);}catch(e){}
    }
    const cnt=$('.wm-promo__count',active.el);
    if(cnt&&active.deadline){
      const tick=()=>{const d=Math.max(0,new Date(active.deadline)-new Date());const dd=Math.floor(d/864e5),hh=Math.floor(d%864e5/36e5),mm=Math.floor(d%36e5/6e4);
        cnt.innerHTML=`<span>${dd}<small>dagen</small></span><span>${hh}<small>uur</small></span><span>${mm}<small>min</small></span>`;};
      tick();setInterval(tick,30000);
    }
  });

  /* hero: dicht → open → labels → kleuren */
  $$('.wm-stage').forEach(stage=>{
    const imgs=$$('.wm-stage__img',stage); if(!imgs.length) return;
    const colors=[...new Set(imgs.map(i=>i.dataset.color))];
    const hots=$$('.wm-hot',stage), dots=$$('.wm-stage__dots button',stage);
    let auto=true,t=[];
    const clear=()=>{t.forEach(clearTimeout);t=[];};
    const show=(c,k)=>imgs.forEach(i=>i.classList.toggle('is-on',i.dataset.color===c&&i.dataset.state===k));
    const play=(c,withClosed)=>{
      clear(); dots.forEach(d=>d.setAttribute('aria-pressed',d.dataset.color===c)); hots.forEach(h=>h.classList.remove('is-on'));
      const hasClosed=imgs.some(i=>i.dataset.color===c&&i.dataset.state==='closed');
      if(withClosed&&hasClosed){show(c,'closed');t.push(setTimeout(()=>show(c,'open'),1100));} else show(c,'open');
      const base=withClosed?1500:500;
      hots.forEach((h,i)=>t.push(setTimeout(()=>h.classList.add('is-on'),base+i*550)));
      if(auto&&colors.length>1) t.push(setTimeout(()=>play(colors[(colors.indexOf(c)+1)%colors.length],false),withClosed?5200:4200));
    };
    dots.forEach(d=>d.addEventListener('click',()=>{auto=false;play(d.dataset.color,false);}));
    play(colors[0],true);
  });
})();
